export default __webpack_public_path__ + "static/media/alektia_logo.029f8b61.png";